import Aos from "../aos/aos";
const Education = () => {
    Aos(1000)
    return (
        <div className="w-full px-4 py-4 mt-4 rounded-lg bg-white/30  flex flex-col space-y-4 justify-center items-center">
            <div className="text-center font-mono text-xl text-yellow-500 font-bold " data-aos="fade-down">EDUCATION/TRAINING</div>
            <div className="flex w-full" data-aos="zoom-in">
                <div className="w-[20%] text-xl font-extrabold text-yellow-400">2021</div>
                <div className="flex flex-col w-[80%]">
                    <div className="text-white font-bold font-mono">FULL-STACK PROGRAMMING CERTIFICATE</div>
                    <div className="text-gray-400 font-bold">Bethel Heritage Institute, Owerri</div>
                    <div className="text-black text-justify">I was certified a full stack web developer by Bethel Heritage Institute Owerri, Nigeria after twelve(12)
                        months intensive web progamming training.
                        The training bordered on how to create webpages user interface
                        using HTML5, CSS3 and tailwind css framework as well as adding user
                        experiences to webpages using javascript, jquery and React js framework. Also, during the training, I was exposed to creating a web application backend using PHP/Laravel and Mysql for database.</div>
                </div>
            </div>
            <div className="flex w-full" data-aos="zoom-in">
                <div className="w-[20%] text-xl font-extrabold text-yellow-400">2021</div>
                <div className="flex flex-col w-[80%]">
                    <div className="text-white font-bold font-mono">BSC IN BUSINESS EDUCATION</div>
                    <div className="text-gray-400 font-bold">Alex Ekwueme Federal University Ndufu-alike, Ebonyi State, Nigeria</div>
                    <div className="text-black text-justify">In the course of my bachelor's degree in business education, I acquired problem-solving and communication skills which helps me in bringing a unique perspective and approach to coding. I thrive on the dynamic nature of web development, staying adaptable and client-focused.</div>
                </div>
            </div>
            <div className="flex w-full" data-aos="zoom-in">
                <div className="w-[20%] text-xl font-extrabold text-yellow-400">2016</div>
                <div className="flex flex-col w-[80%]">
                    <div className="text-white font-bold font-mono">WEST AFRICAN SENIOR SCHOOL CERTIFICATE(WASSC)</div>
                    <div className="text-gray-400 font-bold">Ferdy Memorial College Okpoma, Cross River State, Nigeria</div>

                </div>
            </div>
            <div className="flex w-full" data-aos="zoom-in">
                <div className="w-[20%] text-xl font-extrabold text-yellow-400">2010</div>
                <div className="flex flex-col w-[80%]">
                    <div className="text-white font-bold font-mono">FIRST SCHOOL LEAVING CERTIFICATE(FSLC)</div>
                    <div className="text-gray-400 font-bold">Community Primary School, Ndioruta Agbaja, Ebonyi State, Nigeria</div>

                </div>
            </div>
        </div>
    );
}

export default Education;